/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jumpy_Elegant_Anteater_ScoldInputs */

const fr_jumpy_elegant_anteater_scold = /** @type {(inputs: Jumpy_Elegant_Anteater_ScoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un favicon`)
};

/**

* @param {Jumpy_Elegant_Anteater_ScoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const jumpy_elegant_anteater_scold = /** @type {((inputs?: Jumpy_Elegant_Anteater_ScoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jumpy_Elegant_Anteater_ScoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_jumpy_elegant_anteater_scold(inputs)
});